import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class UserShowReferralsRoute extends Route {
  @service declare session: any

  model() {
    return this.modelFor("user.show")
  }
}
